
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/[[...slug]]",
      function () {
        return require("private-next-pages/learn/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/[[...slug]]"])
      });
    }
  